import axios from '../axios';

export default {
  getDoors (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/${id}/door`)
        .then((response) => {
          resolve(response.data);
        })
        .catch(error => reject(error));
    });
  },
  updateDoor (data) {
    return new Promise((resolve, reject) => {
      axios.put(`/doorphone/${data.id}/door/${data.doornum}`, {
        name: data.name,
        is_active: data.is_active,
        separate: data.separate,
      })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getDoorsBarrier (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/barrier/${id}/door`)
        .then((response) => {
          resolve(response.data);
        })
        .catch(error => reject(error));
    });
  },
  updateDoorBarrier (data) {
    return new Promise((resolve, reject) => {
      axios.put(`/barrier/${data.id}/door/${data.doornum}`, {
        name: data.name,
        is_active: data.is_active,
        separate: data.separate,
      })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  newDoorBarrier (params) {
    return new Promise((resolve, reject) => {
      axios.post(`/barrier/${params.id}/door`, params)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  removeDoorBarrier (id, doornum) {
    return new Promise((resolve, reject) => {
      axios.delete(`/barrier/${id}/door/${doornum}`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  editDoorOpenMod (id, doorOpen, num) {
    return new Promise((resolve, reject) => {
      axios.post(`/doorphone/${id}/door/${num}/door-open-mode`, {
        door_open_mode: doorOpen,
      })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getInfoDoorOpen (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/${id}/door/door-open-mode`)
        .then((response) => {
          resolve(response.data);
        })
        .catch(error => reject(error));
    });
  },
};
